function startLoadScreen(){
  $('#loading').css('display', 'flex');
}

function endLoadScreen(){
  $('#loading').css('display', 'none');
}

jQuery(document).ready(function() {

  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          //Calculate header height because this is relative positioning
          if($('#admin_bar_iframe')[0]){
            var headerHeight = $('#shopify-section-header').outerHeight() + $('.page-sub-nav').outerHeight() + $('#admin_bar_iframe').outerHeight();
          }else{
            var headerHeight = $('#shopify-section-header').outerHeight() + $('.page-sub-nav').outerHeight();
          }
          $('html, body').stop().animate({
            scrollTop: target.offset().top - headerHeight
          }, 500, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
  });

  var sections = $('.section'),
      jqWindow = $(window),
      links = $('.nav-item');

  jqWindow.scroll(setActive);
  let previousPosition = 0;
  function setActive() {
    var currentPosition = jqWindow.scrollTop();
    links.removeClass('active');
    sections.removeClass('active').each(function() {
        if($('#admin_bar_iframe')[0]){
          var headerHeight = $('#shopify-section-header').outerHeight() + $('.page-sub-nav').outerHeight() + $('#admin_bar_iframe').outerHeight();
        }else{
          var headerHeight = $('#shopify-section-header').outerHeight() + $('.page-sub-nav').outerHeight();
        }
        var top = $(this).offset().top - headerHeight - 1,
            bottom = top + $(this).height();
        if (currentPosition >= top && currentPosition <= bottom) {
            $(this).addClass('active');
            var link = $('a[href="/pages/about#' + this.id + '"]');
            if (link.length === 0) {
              link = $('a[href="#' + this.id + '"]');
            }
            link.addClass('active');
        }
    });

    if (currentPosition > previousPosition) {
      $('#search-subnav').addClass('hide-search');
    } else {
      $('#search-subnav').removeClass('hide-search');
    }
    previousPosition = currentPosition;
  }

  setActive();

  $('.header-register').hover(function(){
    $(this).find('.register-note').stop().slideDown();
  }, function(){
    $(this).find('.register-note').stop().slideUp();
  });

  $('.search-button').on('click', function(){
    $('.search-bar').stop().slideToggle(function(){
      $('.search-bar input[type="search"]').focus();
    });
  });

  /* $('.my-showroom .fa-caret-down').on('click', function(){
    $('.my-showroom').addClass('active');
  });

  $('.my-showroom .fa-caret-up').on('click', function(){
    $('.my-showroom').removeClass('active');
  }); */

});

function openUser() {
  console.log('open');
    document.getElementById("myDropdown").classList.toggle("show");
}

// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn') &&
    !event.target.parentNode.matches('.dropbtn') &&
    !event.target.parentNode.matches('.dropdown-content') &&
    !event.target.parentNode.parentNode.matches('.dropdown-content')&&
    !event.target.parentNode.parentNode.parentNode.matches('.dropdown-content')) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
  }
}
